import { CheckmarkFilled16 } from '@carbon/icons-react';
import React from 'react';
export default {
  CheckmarkFilled16,
  React
};